import { useQuery } from "@tanstack/react-query";
import instance from "@src/api/axiosInstance";

const useGetPrompts = ({ open }) => {

  const { data = [], isFetching, isError } = useQuery(
    ['system-prompts'],
    async () => {
      const response = await instance.get(`/nexa/system-prompt/list`);
      return response.data;
    },
    {
      enabled: open,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1 * 60 * 1000, // 1m
      notifyOnChangeProps: ['isFetching', 'isError', 'data']
    }
  );

  return { data, isFetching, isError }
}

export default useGetPrompts;
